import clsx from "clsx"
import React from "react"
import { Button, type IButtonProps } from "@/shared/ui/button"

export function SecondaryButton(props: IButtonProps) {
  return <Button variant="outlined" color="inherit" {...props} className={clsx("border-Gray bg-Gray active:bg-zinc-300", props.className)} />
}
